module.exports = __webpack_public_path__ + "static/media/img_60.29fb1d17.png";